import React from 'react'

const MainButton = ({ onClick, label, className = "hover:text-main-blue hover:border-main-blue", selectState = false }) => {

    return (
        <button
            type='submit'
            onClick={onClick}
            className={`border ${selectState ? 'border-main-blue text-main-blue font-medium' : 'font-normal  border-main-border  text-main-subfont'}  group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-lg px-6  transition  hover:scale-105 ${className}`}
        >
            <span>{label}</span>
            <div className="absolute ">
                <div className="relative h-full w-8 bg-white/20"></div>
            </div>
        </button>
    )
}

export default MainButton